import React, { useState } from 'react';
import { CountdownTimer } from './CountdownTimer';
const finalOptions = [{
  id: 'primaria',
  emoji: '📘',
  title: 'PRIMARIA',
  description: '6 Tomos Primaria + 6 Bonos',
  price: '$19.990',
  ctaText: '→ QUIERO MI MEGAPACK PRIMARIA',
  ctaHref: 'https://www.profepack.com/cart/48097228128512:1'
}, {
  id: 'completo',
  emoji: '🏆',
  title: 'PACK COMPLETO',
  description: 'Primaria + Secundaria + 6 Bonos + Adaptaciones',
  price: '$27.990',
  ctaText: '→ QUIERO EL PACK COMPLETO',
  ctaHref: 'https://www.profepack.com/cart/48175123562752:1',
  isFeatured: true
}, {
  id: 'secundaria',
  emoji: '📗',
  title: 'SECUNDARIA',
  description: '6 Tomos Secundaria + 6 Bonos',
  price: '$19.990',
  ctaText: '→ QUIERO MI MEGAPACK SECUNDARIA',
  ctaHref: 'https://www.profepack.com/cart/48175173173504:1'
}];
export function FinalCTA() {
  const [selected, setSelected] = useState('completo');
  const selectedOption = finalOptions.find(o => o.id === selected)!;
  return <section className="w-full bg-black py-20 px-4" data-id="element-127">
      <div className="max-w-4xl mx-auto text-center" data-id="element-128">
        <div className="text-[#FFD700] text-3xl font-black tracking-widest mb-8" data-id="element-129">
          ✝️ PROFEPACK™
        </div>

        <h2 className="text-2xl sm:text-3xl font-bold text-white mb-3" data-id="element-130">
          La próxima semana podés seguir buscando recursos en internet.
        </h2>
        <p className="text-[#FFD700] text-2xl sm:text-3xl font-black mb-10" data-id="element-131">
          O podés tener todo el año resuelto desde hoy.
        </p>

        {/* Compact Cost Table */}
        <div className="bg-[#1a1400] border border-[#FFD700]/30 rounded-2xl overflow-hidden mb-12 max-w-2xl mx-auto text-left" data-id="element-132">
          <div className="p-3 bg-[#0d0a00] border-b border-[#FFD700]/30 text-center font-bold text-white text-sm" data-id="element-133">
            ¿Cuánto cuesta realmente NO tenerlo?
          </div>
          {[['3 hs de preparación × 40 semanas = 120 horas de tu vida por año', 'Planificación lista en 10 minutos'], ['Recursos sin progresión ni criterio pedagógico', '12 tomos con objetivos claros por edad y nivel de fe'], ['Responder quejas de familias sin saber qué decir', '60 mensajes listos para copiar y pegar'], ['Improvisar cuando el grupo se descontrola', 'Guiones y dinámicas listas para cualquier situación'], ['Sin criterio de evaluación para mostrar a directivos', 'Rúbricas, evidencias e informes listos para entregar'], ['Sin conexión con el Año Litúrgico', 'Calendario litúrgico aplicado con aperturas listas por mes'], ['Llegar sin plan cuando el tiempo se redujo', 'Kits de clase de 10 y 20 minutos listos para usar'], ['Sin hilo conductor entre los años', '12 tomos con progresión de fe de 1° Primaria a 6° Secundaria']].map(([without, withPack], i) => <div key={i} className="grid grid-cols-1 sm:grid-cols-2 border-b border-gray-800 last:border-b-0" data-id="element-134">
              <div className="p-3 text-gray-400 text-xs sm:text-sm" data-id="element-135">
                {without}
              </div>
              <div className="p-3 text-white font-bold text-xs sm:text-sm bg-[#FFD700]/5 sm:border-l border-gray-800" data-id="element-136">
                {withPack}
              </div>
            </div>)}
        </div>

        {/* Countdown */}
        <div className="mb-4" data-id="element-137">
          <p className="text-white font-bold mb-4" data-id="element-138">
            ⏰ El precio de lanzamiento cierra en:
          </p>
          <CountdownTimer size="lg" blinking={true} data-id="element-139" />
        </div>
        <p className="text-gray-300 text-sm mb-12" data-id="element-140">
          Después sube{' '}
          <span className="text-[#FF0000] font-bold" data-id="element-141">$8.000 ARS</span> y no
          vuelve.
        </p>

        {/* 3 radio-selection pricing options */}
        <div className="space-y-3 mb-6 max-w-xl mx-auto" data-id="element-142">
          {finalOptions.map(option => {
          const isSelected = selected === option.id;
          const isFeatured = option.isFeatured;
          return <button key={option.id} onClick={() => setSelected(option.id)} className={`w-full text-left rounded-xl p-4 transition-all ${isFeatured && isSelected ? 'border-2 border-[#FFD700] bg-[#0d0a00] shadow-[0_0_30px_rgba(255,215,0,0.15)]' : isFeatured ? 'border-2 border-[#FFD700]/50 bg-[#0d0a00]' : isSelected ? 'border-2 border-[#FFD700] bg-[#0a0a0a]' : 'border border-white/10 bg-[#0a0a0a]'}`} data-id="element-143">
                <div className="flex items-center gap-3" data-id="element-144">
                  <div className={`w-6 h-6 rounded-full border-2 flex-shrink-0 flex items-center justify-center ${isSelected ? 'border-[#FFD700]' : 'border-white/30'}`} data-id="element-145">
                    {isSelected && <div className="w-3 h-3 rounded-full bg-[#FFD700]" data-id="element-146" />}
                  </div>

                  <div className="flex-1 min-w-0" data-id="element-147">
                    <div className="flex items-center gap-2" data-id="element-148">
                      <span className="text-lg" data-id="element-149">{option.emoji}</span>
                      <span className="text-white font-black text-base" data-id="element-150">
                        {option.title}
                      </span>
                    </div>
                    {isFeatured && <span className="inline-block bg-[#FFD700] text-black text-[11px] font-black px-2.5 py-0.5 rounded-full mt-1.5" data-id="element-151">
                        ⭐ MÁS ELEGIDO
                      </span>}
                    <p className="text-gray-400 text-xs mt-1" data-id="element-152">
                      {option.description}
                    </p>
                  </div>

                  <div className="text-right flex-shrink-0" data-id="element-153">
                    <div className={`font-black text-2xl ${isFeatured ? 'text-[#FFD700]' : 'text-white'}`} data-id="element-154">
                      {option.price}
                    </div>
                  </div>
                </div>
              </button>;
        })}
        </div>

        <a href={selectedOption.ctaHref} className="btn-green-pulse block w-full max-w-xl mx-auto text-center bg-[#FFD700] text-black font-black text-base sm:text-xl py-4 sm:py-5 rounded-xl hover:bg-[#FFE44D] transition-colors mb-4" data-id="element-155">
          {selectedOption.ctaText}
        </a>

        {/* Final trust bar */}
        <div className="flex flex-wrap items-center justify-center gap-3 text-sm text-gray-300 mt-8" data-id="element-156">
          <span data-id="element-157">🔒 Pago 100% seguro</span>
          <span data-id="element-158">⚡ Acceso en 5 minutos</span>
          <span data-id="element-159">🛡️ Garantía 7 días sin preguntas</span>
          <span data-id="element-160">
            💳 Mercado Pago | Tarjeta de crédito | Transferencia bancaria
          </span>
        </div>
      </div>
    </section>;
}